<template>
  <v-container grid-list-xs>
    <v-card>
      <v-card-title>Catálogo de produtos</v-card-title>
      <v-card-text v-if="!groupSelected">Selecione um Grupo</v-card-text>
      <template v-else>
        <v-tabs v-model="tab" color="deep-purple-accent-4" align-tabs="start">
          <v-tab value="products">Produtos</v-tab>
          <v-tab value="categories">Categorias</v-tab>
        </v-tabs>

        <v-window v-model="tab">
          <!-- Products tab (same role as Cashiers "Lista") -->
          <v-window-item value="products">
            <v-row>
              <v-col cols="12">
                <v-form :submit="submitSearch">
                  <v-expansion-panels variant="accordion" v-model="filterPanel">
                    <v-expansion-panel value="searchFiltersPanel" rounded="lg">
                      <v-expansion-panel-title
                        style="color:#000000 !important; background-color: #e0e0e0ff; opacity: 1 !important"
                      >
                        <v-row style="opacity: 1 !important">
                          <v-col cols="3">
                            <span class="v-card-title">Filtro de pesquisa</span>
                          </v-col>
                          <v-col cols="9" class="pe-10 d-flex justify-end align-center flex-wrap ga-2">
                            <DialogCreateUpdateProduct
                              :user="user"
                              v-model="editProductModel"
                              :floatRight="true"
                              :categories="activeCategories"
                              @created="createdProduct"
                              @updated="updatedProduct"
                            />
                          </v-col>
                        </v-row>
                      </v-expansion-panel-title>
                      <v-expansion-panel-text class="bg-grey-lighten-2">
                        <v-row>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="filters.searchText"
                              label="Nome"
                              clearable
                              density="compact"
                              hide-details
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-select
                              v-model="filters.category_id"
                              :items="categoryFilterItems"
                              item-title="title"
                              item-value="value"
                              label="Categoria"
                              clearable
                              density="compact"
                              hide-details
                            ></v-select>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-select
                              v-model="filters.active"
                              :items="boolFilterItems"
                              item-title="title"
                              item-value="value"
                              label="Ativo"
                              clearable
                              density="compact"
                              hide-details
                            ></v-select>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-select
                              v-model="filters.pdv_visible"
                              :items="boolFilterItems"
                              item-title="title"
                              item-value="value"
                              label="Visível PDV"
                              clearable
                              density="compact"
                              hide-details
                            ></v-select>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-select
                              v-model="filters.kind"
                              :items="kindFilterItems"
                              item-title="title"
                              item-value="value"
                              label="Tipo"
                              clearable
                              density="compact"
                              hide-details
                            ></v-select>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-select
                              :items="[50, 100, 200]"
                              v-model="filters.itemsPerPage"
                              label="Resultados por página"
                              density="compact"
                              hide-details
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-card-actions>
                          <v-btn color="warning" @click="clearFilters()">
                            <v-icon class="mr-2">mdi-broom</v-icon>
                            Limpar pesquisa
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" type="submit" :loading="requestingApi">
                            <v-icon class="mr-2">mdi-magnify</v-icon>
                            Pesquisar
                          </v-btn>
                        </v-card-actions>
                      </v-expansion-panel-text>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-form>
              </v-col>
              <v-col cols="12">
                <v-card>
                  <v-data-table
                    :headers="productHeaders"
                    :items="lstObjects"
                    :items-per-page="filters.itemsPerPage"
                    return-object
                    class="elevation-1"
                    hide-default-footer
                  >
                    <template v-slot:bottom>
                      <div class="text-center pt-2">
                        <v-pagination
                          :disabled="requestingApi"
                          v-model="page"
                          :length="maxPage"
                        ></v-pagination>
                      </div>
                    </template>
                    <template v-slot:item.category="{ item }">
                      <span>{{ categoryName(item) }}</span>
                    </template>
                    <template v-slot:item.kind="{ value }">
                      <v-chip
                        size="small"
                        variant="tonal"
                        :color="value === 'ticket' ? 'deep-purple' : 'default'"
                      >
                        {{ kindLabel(value) }}
                      </v-chip>
                    </template>
                    <template v-slot:item.base_price="{ value }">
                      <span>{{ formatPrice(value) }}</span>
                    </template>
                    <template v-slot:item.active="{ value }">
                      <span>{{ value ? 'Sim' : 'Não' }}</span>
                    </template>
                    <template v-slot:item.pdv_visible="{ value }">
                      <span>{{ value ? 'Sim' : 'Não' }}</span>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-menu>
                        <template v-slot:activator="{ props }">
                          <v-btn icon variant="text" v-bind="props">
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item @click="editProduct(item)">
                            <v-list-item-title>
                              <v-icon color="primary" class="mr-2">mdi-pencil</v-icon>
                              Editar
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="removeProduct(item)">
                            <v-list-item-title>
                              <v-icon color="red" class="mr-2">mdi-delete</v-icon>
                              Excluir
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-window-item>

          <!-- Categories tab (same role as Cashiers "Livro Caixa") -->
          <v-window-item value="categories">
            <v-row>
              <v-col cols="12">
                <v-form :submit="submitCategorySearch">
                  <v-expansion-panels variant="accordion" v-model="categoryFilterPanel">
                    <v-expansion-panel value="categorySearchFiltersPanel" rounded="lg">
                      <v-expansion-panel-title
                        style="color:#000000 !important; background-color: #e0e0e0ff; opacity: 1 !important"
                      >
                        <v-row style="opacity: 1 !important">
                          <v-col cols="3">
                            <span class="v-card-title">Filtro de categorias</span>
                          </v-col>
                          <v-col cols="9" class="pe-10 d-flex justify-end align-center">
                            <v-btn color="primary" class="float-right" @click.stop="openCategoryDialog()">
                              <v-icon class="mr-1">mdi-plus</v-icon>
                              Nova categoria
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-title>
                      <v-expansion-panel-text class="bg-grey-lighten-2">
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="categoryFilters.searchText"
                              label="Nome"
                              clearable
                              density="compact"
                              hide-details
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-select
                              v-model="categoryFilters.active"
                              :items="boolFilterItems"
                              item-title="title"
                              item-value="value"
                              label="Ativa"
                              clearable
                              density="compact"
                              hide-details
                            ></v-select>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-select
                              :items="[50, 100, 200]"
                              v-model="categoryFilters.itemsPerPage"
                              label="Resultados por página"
                              density="compact"
                              hide-details
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-card-actions>
                          <v-btn color="warning" @click="clearCategoryFilters()">
                            <v-icon class="mr-2">mdi-broom</v-icon>
                            Limpar pesquisa
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" type="submit" :loading="requestingCategories">
                            <v-icon class="mr-2">mdi-magnify</v-icon>
                            Pesquisar
                          </v-btn>
                        </v-card-actions>
                      </v-expansion-panel-text>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-form>
              </v-col>
              <v-col cols="12">
                <v-card>
                  <v-data-table
                    :headers="categoryHeaders"
                    :items="categoryList"
                    :items-per-page="categoryFilters.itemsPerPage"
                    :loading="requestingCategories"
                    return-object
                    class="elevation-1"
                    hide-default-footer
                  >
                    <template v-slot:bottom>
                      <div class="text-center pt-2">
                        <v-pagination
                          :disabled="requestingCategories"
                          v-model="categoryPage"
                          :length="categoryMaxPage"
                        ></v-pagination>
                      </div>
                    </template>
                    <template v-slot:item.fields_count="{ item }">
                      <span>{{ (item.fields || []).length }}</span>
                    </template>
                    <template v-slot:item.active="{ value }">
                      <v-chip
                        size="small"
                        variant="tonal"
                        :color="value ? 'success' : 'default'"
                      >
                        {{ value ? 'Ativa' : 'Inativa' }}
                      </v-chip>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-menu>
                        <template v-slot:activator="{ props }">
                          <v-btn icon variant="text" v-bind="props">
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item @click="openCategoryDialog(item)">
                            <v-list-item-title>
                              <v-icon color="primary" class="mr-2">mdi-pencil</v-icon>
                              Editar
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-window-item>
        </v-window>

        <v-dialog v-model="categoryDialog" max-width="860" scrollable>
          <v-card>
            <v-toolbar
              color="secondary"
              :title="categoryForm.id ? 'Editar categoria' : 'Nova categoria'"
            >
              <v-btn color="black" @click="categoryDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-row dense>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Nome"
                    v-model="categoryForm.name"
                    :rules="[(v) => !!v || 'Campo obrigatório']"
                    density="compact"
                    :disabled="requestingCategory"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Ordem"
                    v-model="categoryForm.sort"
                    type="number"
                    density="compact"
                    :disabled="requestingCategory"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3" class="d-flex align-center">
                  <v-switch
                    color="green"
                    :label="categoryForm.active ? 'Ativa' : 'Inativa'"
                    v-model="categoryForm.active"
                    :disabled="requestingCategory"
                    hide-details
                  ></v-switch>
                </v-col>
              </v-row>

              <div class="text-subtitle-2 mt-2 mb-1">Campos da categoria</div>

              <v-alert
                v-if="variantComboCount > 0"
                :type="variantComboCount > 200 ? 'error' : variantComboCount > 50 ? 'warning' : 'info'"
                variant="tonal"
                density="compact"
                class="mb-3"
              >
                Combinações de variação: <strong>{{ variantComboCount }}</strong>
                <span v-if="variantComboCount > 200"> — máximo 200; ajuste opções antes de salvar.</span>
                <span v-else-if="variantComboCount > 50"> — muitas combinações; a grade de estoque pode ficar pesada.</span>
              </v-alert>

              <div
                v-for="(field, idx) in categoryForm.fields"
                :key="field._uid || field.id || idx"
                class="mb-3 pa-3 rounded border"
                style="border: 1px solid rgba(0,0,0,0.12)"
              >
                <v-row dense align="center">
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field
                      label="Rótulo"
                      v-model="field.label"
                      density="compact"
                      :disabled="requestingCategory"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-select
                      label="Tipo de campo"
                      v-model="field.type"
                      :items="fieldTypeItemsFor(field)"
                      item-title="title"
                      item-value="value"
                      density="compact"
                      :disabled="requestingCategory"
                      hide-details="auto"
                      @update:model-value="onFieldTypeChange(field)"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-select
                      label="Tipo"
                      v-model="field.role"
                      :items="fieldRoleItems"
                      item-title="title"
                      item-value="value"
                      density="compact"
                      :disabled="requestingCategory"
                      hide-details="auto"
                      @update:model-value="onFieldRoleChange(field)"
                    >
                      <template #append-inner>
                        <v-tooltip location="top" max-width="300">
                          <template #activator="{ props: tip }">
                            <v-icon
                              v-bind="tip"
                              size="small"
                              icon="mdi-information-outline"
                              class="ms-1"
                              tabindex="-1"
                            ></v-icon>
                          </template>
                          <span>
                            Variação exige select e cria combinações com estoque (e preço opcional)
                            por combinação. Atributo é só informação e não divide estoque
                            (ex.: validade como data).
                          </span>
                        </v-tooltip>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="10" sm="5" md="2">
                    <v-checkbox
                      v-model="field.required"
                      label="Obrigatório"
                      density="compact"
                      hide-details
                      :disabled="requestingCategory"
                      class="mt-0"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="2" sm="1" md="1" class="d-flex justify-end">
                    <v-btn
                      icon
                      variant="text"
                      color="error"
                      density="compact"
                      :disabled="requestingCategory"
                      aria-label="Remover campo"
                      @click="removeCategoryField(idx)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col v-if="field.type === 'select'" cols="12">
                    <v-combobox
                      label="Opções"
                      v-model="field.options"
                      multiple
                      chips
                      closable-chips
                      density="compact"
                      :disabled="requestingCategory"
                      hint="Enter para adicionar. Máx. 50."
                      persistent-hint
                    ></v-combobox>
                  </v-col>
                </v-row>
              </div>

              <v-btn
                color="primary"
                variant="tonal"
                size="small"
                type="button"
                :disabled="requestingCategory"
                @click.stop.prevent="addCategoryField"
              >
                <v-icon class="mr-1">mdi-plus</v-icon>
                Adicionar campo
              </v-btn>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn variant="text" color="error" @click="categoryDialog = false">Cancelar</v-btn>
              <v-btn
                color="success"
                :loading="requestingCategory"
                :disabled="requestingCategory || variantComboCount > 200"
                @click="saveCategory"
              >
                <v-icon class="mr-2">mdi-content-save</v-icon>
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </v-card>
  </v-container>
</template>
<script>
import DialogCreateUpdateProduct from '../components/DialogCreateUpdateProduct.vue'
import api from '@/services'
import { normalizeListPayload } from '@/utils/listPayload'

export default {
  components: { DialogCreateUpdateProduct },
  props: {
    user: Object,
  },
  data() {
    return {
      tab: 'products',
      requestingApi: false,
      requestingCategories: false,
      requestingCategory: false,
      productHeaders: [
        { title: 'Nome', align: 'start', key: 'name', sortable: true },
        { title: 'Tipo', align: 'start', key: 'kind', sortable: true },
        { title: 'Categoria', align: 'start', key: 'category', sortable: false },
        { title: 'Preço base', align: 'end', key: 'base_price', sortable: true },
        { title: 'Ativo', align: 'center', key: 'active', sortable: true },
        { title: 'Visível PDV', align: 'center', key: 'pdv_visible', sortable: true },
        { title: 'Ações', key: 'actions', align: 'end', sortable: false },
      ],
      categoryHeaders: [
        { title: 'Nome', align: 'start', key: 'name', sortable: true },
        { title: 'Campos', align: 'center', key: 'fields_count', sortable: false },
        { title: 'Ordem', align: 'end', key: 'sort', sortable: true },
        { title: 'Ativa', align: 'center', key: 'active', sortable: true },
        { title: 'Ações', key: 'actions', align: 'end', sortable: false },
      ],
      fieldTypeItems: [
        { title: 'Texto', value: 'text' },
        { title: 'Número', value: 'number' },
        { title: 'Select', value: 'select' },
        { title: 'Data', value: 'date' },
      ],
      fieldRoleItems: [
        { title: 'Variação (estoque)', value: 'variant' },
        { title: 'Atributo (info)', value: 'attribute' },
      ],
      _fieldUid: 1,
      lstObjects: [],
      categoryList: [],
      categories: [],
      filters: {
        searchText: null,
        category_id: null,
        active: null,
        pdv_visible: null,
        kind: null,
        itemsPerPage: 50,
      },
      kindFilterItems: [
        { title: 'Todos', value: null },
        { title: 'Padrão', value: 'standard' },
        { title: 'Ingresso', value: 'ticket' },
      ],
      categoryFilters: {
        searchText: null,
        active: null,
        itemsPerPage: 50,
      },
      page: 1,
      maxPage: 1,
      categoryPage: 1,
      categoryMaxPage: 1,
      filterPanel: 'searchFiltersPanel',
      categoryFilterPanel: 'categorySearchFiltersPanel',
      editProductModel: {},
      categoryDialog: false,
      categoryForm: {
        id: null,
        name: '',
        sort: 0,
        active: true,
        fields: [],
      },
      boolFilterItems: [
        { title: 'Todos', value: null },
        { title: 'Sim', value: true },
        { title: 'Não', value: false },
      ],
    }
  },
  created() {
    const vm = this
    const saved = localStorage['_products_itemsPerPage']
    if (saved) {
      vm.filters.itemsPerPage = parseInt(saved, 10) || 50
    }
    const catSaved = localStorage['_product_categories_itemsPerPage']
    if (catSaved) {
      vm.categoryFilters.itemsPerPage = parseInt(catSaved, 10) || 50
    }
  },
  activated() {
    if (this.groupSelected) {
      this.loadCategoriesForProducts()
      if (this.tab === 'products') {
        this.fetchList(this.page)
      } else {
        this.fetchCategories(this.categoryPage)
      }
    }
  },
  mounted() {
    if (this.groupSelected) {
      this.loadCategoriesForProducts()
      this.fetchList(1)
    }
  },
  methods: {
    categoryName(item) {
      if (!item) return '—'
      if (item.category?.name) return item.category.name
      if (item.category_id) {
        const found = this.categories.find((c) => c.id === item.category_id)
        return found?.name || '—'
      }
      return '—'
    },
    kindLabel(value) {
      if (value === 'ticket') return 'Ingresso'
      return 'Padrão'
    },
    formatPrice(value) {
      if (value === null || value === undefined || value === '') return '—'
      const n = Number(value)
      if (isNaN(n)) return value
      return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    emptyCategoryField() {
      return {
        _uid: this._fieldUid++,
        id: null,
        key: null,
        label: '',
        type: 'text',
        role: 'attribute',
        required: false,
        options: [],
        active: true,
        sort: (this.categoryForm?.fields || []).length,
      }
    },
    mapFieldsFromApi(fields) {
      return (fields || []).map((f) => ({
        _uid: this._fieldUid++,
        id: f.id || null,
        key: f.key || null,
        label: f.label || '',
        type: f.type || 'text',
        role: f.role === 'variant' ? 'variant' : 'attribute',
        required: f.required !== false && f.required !== 0,
        options: Array.isArray(f.options) ? [...f.options] : [],
        active: f.active !== false,
        sort: f.sort != null ? f.sort : 0,
      }))
    },
    fieldTypeItemsFor(field) {
      // Variação only makes sense as select — lock type list when role is variant
      if (field?.role === 'variant') {
        return this.fieldTypeItems.filter((t) => t.value === 'select')
      }
      return this.fieldTypeItems
    },
    onFieldTypeChange(field) {
      if (!field) return
      if (field.type !== 'select') {
        field.role = 'attribute'
        field.options = []
      } else if (!Array.isArray(field.options)) {
        field.options = []
      }
    },
    onFieldRoleChange(field) {
      if (!field) return
      if (field.role === 'variant') {
        // Contract: variant ⇒ select only
        field.type = 'select'
        if (!Array.isArray(field.options)) field.options = []
        if (!field.required) field.required = true
      }
    },
    addCategoryField() {
      if (!Array.isArray(this.categoryForm.fields)) {
        this.categoryForm.fields = []
      }
      this.categoryForm.fields.push(this.emptyCategoryField())
    },
    removeCategoryField(idx) {
      if (!this.categoryForm.fields) return
      this.categoryForm.fields.splice(idx, 1)
    },
    buildFieldsPayload() {
      return (this.categoryForm.fields || []).map((f, i) => {
        const type = f.type || 'text'
        let role = f.role === 'variant' ? 'variant' : 'attribute'
        if (type !== 'select') role = 'attribute'
        const row = {
          label: String(f.label || '').trim(),
          type,
          role,
          required: !!f.required,
          sort: f.sort != null && f.sort !== '' ? Number(f.sort) : i,
          active: f.active !== false,
        }
        if (f.id) row.id = f.id
        if (f.key) row.key = f.key
        if (type === 'select') {
          row.options = (Array.isArray(f.options) ? f.options : [])
            .map((o) => String(o).trim())
            .filter(Boolean)
        }
        return row
      })
    },
    openCategoryDialog(item) {
      if (item?.id) {
        // Prefer fields already loaded; otherwise fetch with withFields
        const apply = (src) => {
          this.categoryForm = {
            id: src.id,
            name: src.name || '',
            sort: src.sort != null ? src.sort : 0,
            active: src.active !== false,
            fields: this.mapFieldsFromApi(src.fields),
          }
          this.categoryDialog = true
        }
        if (item.fields) {
          apply(item)
          return
        }
        return api.productCategory
          .list({ searchText: item.name, withFields: true, itemsPerPage: 50 })
          .then((result) => {
            const { items } = normalizeListPayload(result)
            const found = (items || []).find((c) => c.id === item.id) || item
            apply(found)
          })
          .catch(() => apply({ ...item, fields: [] }))
      }
      this.categoryForm = {
        id: null,
        name: '',
        sort: 0,
        active: true,
        fields: [],
      }
      this.categoryDialog = true
    },
    saveCategory() {
      const vm = this
      if (vm.requestingCategory) return
      if (!vm.categoryForm?.name) {
        vm.$notify({ type: 'warn', text: 'Nome da categoria é obrigatório' })
        return
      }
      if (vm.variantComboCount > 200) {
        vm.$notify({ type: 'warn', text: 'Máximo de 200 combinações de variação' })
        return
      }
      const fields = vm.buildFieldsPayload()
      for (const f of fields) {
        if (!f.label) {
          vm.$notify({ type: 'warn', text: 'Todo campo precisa de rótulo' })
          return
        }
        if (f.type === 'select' && (!f.options || !f.options.length)) {
          vm.$notify({ type: 'warn', text: `Campo "${f.label}": opções obrigatórias no select` })
          return
        }
        if (f.role === 'variant' && f.type !== 'select') {
          vm.$notify({ type: 'warn', text: `Campo "${f.label}": variação exige tipo select` })
          return
        }
      }
      vm.requestingCategory = true
      const payload = {
        name: vm.categoryForm.name,
        sort:
          vm.categoryForm.sort != null && vm.categoryForm.sort !== ''
            ? Number(vm.categoryForm.sort)
            : 0,
        active: vm.categoryForm.active !== false,
        fields,
      }
      if (vm.categoryForm.id) {
        payload.id = vm.categoryForm.id
      }
      return api.productCategory
        .updateOrCreate(payload)
        .then((result) => {
          vm.categoryDialog = false
          const isEdit = !!payload.id
          vm.$notify({
            type: 'success',
            text: isEdit ? 'Categoria atualizada' : 'Categoria criada com sucesso',
          })
          vm.loadCategoriesForProducts()
          if (result?.id) {
            const exists = vm.categoryList.some((c) => c.id === result.id)
            if (exists) {
              vm.categoryList = vm.categoryList.map((c) =>
                c.id === result.id ? result : c
              )
            } else if (vm.tab === 'categories') {
              vm.categoryList = [result, ...vm.categoryList]
            }
          } else if (vm.tab === 'categories') {
            vm.fetchCategories(vm.categoryPage)
          }
        })
        .catch((err) => {
          if (err?.message) {
            vm.$notify({ type: 'warn', text: err.message })
          }
        })
        .finally(() => {
          vm.requestingCategory = false
        })
    },
    /** Active categories for product form/filter (and name resolution). */
    loadCategoriesForProducts() {
      const vm = this
      if (!vm.groupSelected) return
      return api.productCategory
        .list({ active: true, withFields: true, itemsPerPage: 200 })
        .then((result) => {
          const { items } = normalizeListPayload(result)
          vm.categories = items
        })
        .catch((err) => {
          if (err?.message) {
            vm.$notify({ type: 'warn', text: err.message })
          }
        })
    },
    clearCategoryFilters() {
      this.categoryFilters.searchText = null
      this.categoryFilters.active = null
    },
    submitCategorySearch(e) {
      if (e?.preventDefault) e.preventDefault()
      this.fetchCategories(1)
    },
    fetchCategories(page) {
      const vm = this
      if (!vm.groupSelected || vm.requestingCategories) return
      vm.requestingCategories = true
      vm.categoryPage = page || 1
      const payload = {
        itemsPerPage: vm.categoryFilters.itemsPerPage,
        withFields: true,
      }
      if (vm.categoryFilters.searchText) {
        payload.searchText = vm.categoryFilters.searchText
      }
      // only send active when filter is set (null = all)
      if (vm.categoryFilters.active === true || vm.categoryFilters.active === false) {
        payload.active = vm.categoryFilters.active
      }
      return api.productCategory
        .list(payload, vm.categoryPage)
        .then((result) => {
          const { items, meta } = normalizeListPayload(result)
          vm.categoryList = items
          if (meta) {
            vm.categoryPage = meta.current_page || vm.categoryPage
            vm.categoryMaxPage = meta.last_page || 1
          } else {
            vm.categoryMaxPage = 1
          }
          vm.categoryFilterPanel = ''
        })
        .catch((err) => {
          if (err?.message) {
            vm.$notify({ type: 'warn', text: err.message })
          }
        })
        .finally(() => {
          vm.requestingCategories = false
        })
    },
    clearFilters() {
      const vm = this
      vm.filters.searchText = null
      vm.filters.category_id = null
      vm.filters.active = null
      vm.filters.pdv_visible = null
      vm.filters.kind = null
    },
    submitSearch(e) {
      if (e?.preventDefault) e.preventDefault()
      this.fetchList(1)
    },
    fetchList(page) {
      const vm = this
      if (!vm.groupSelected || vm.requestingApi) return
      vm.requestingApi = true
      vm.page = page || 1
      // Do not send active/pdv_visible when null — Laravel exists()+ (bool)null
      // becomes false and hides all active/visible products.
      // kind filter: BE product/list has no kind yet — client filter on page.
      const payload = {
        searchText: vm.filters.searchText || undefined,
        category_id: vm.filters.category_id || undefined,
        withCategory: true,
        itemsPerPage: vm.filters.itemsPerPage,
      }
      if (vm.filters.active === true || vm.filters.active === false) {
        payload.active = vm.filters.active
      }
      if (vm.filters.pdv_visible === true || vm.filters.pdv_visible === false) {
        payload.pdv_visible = vm.filters.pdv_visible
      }
      return api.product
        .list(payload, vm.page)
        .then((result) => {
          const { items, meta } = normalizeListPayload(result)
          let list = items || []
          if (vm.filters.kind === 'ticket' || vm.filters.kind === 'standard') {
            list = list.filter((p) => (p.kind || 'standard') === vm.filters.kind)
          }
          vm.lstObjects = list
          if (meta) {
            vm.page = meta.current_page || vm.page
            vm.maxPage = meta.last_page || 1
          } else {
            vm.maxPage = 1
          }
          vm.filterPanel = ''
        })
        .catch((err) => {
          if (err?.message) {
            vm.$notify({ type: 'warn', text: err.message })
          }
        })
        .finally(() => {
          vm.requestingApi = false
        })
    },
    editProduct(item) {
      if (!item?.id) {
        this.editProductModel = { ...item }
        return
      }
      // Load full product with attributes + variants for the form
      return api.product
        .list({
          searchText: item.name,
          withCategory: true,
          withCategoryFields: true,
          withAttributes: true,
          withVariants: true,
          itemsPerPage: 20,
        })
        .then((result) => {
          const { items } = normalizeListPayload(result)
          const full = (items || []).find((p) => p.id === item.id) || item
          this.editProductModel = { ...full }
        })
        .catch(() => {
          this.editProductModel = { ...item }
        })
    },
    createdProduct(val) {
      const vm = this
      vm.editProductModel = {}
      if (val) {
        vm.lstObjects = [val, ...vm.lstObjects]
      } else {
        vm.fetchList(vm.page)
      }
    },
    updatedProduct(val) {
      const vm = this
      vm.editProductModel = {}
      if (val?.id) {
        vm.lstObjects = vm.lstObjects.map((o) => (o.id === val.id ? val : o))
      } else {
        vm.fetchList(vm.page)
      }
    },
    removeProduct(item) {
      const vm = this
      if (!item?.id || !vm.groupSelected) return
      const name = item.name || `#${item.id}`
      const ok = confirm(
        `Excluir "${name}"?\n\n` +
          'Se o produto nunca foi vendido, será removido. ' +
          'Se já houver venda, ele será apenas inativado.'
      )
      if (!ok) return
      return api.product
        .delete(item.id)
        .then((result) => {
          if (result?.deleted) {
            vm.lstObjects = vm.lstObjects.filter((o) => o.id !== item.id)
            vm.$notify({ type: 'success', text: 'Produto excluído' })
            return
          }
          if (result?.inactivated && result?.product) {
            vm.lstObjects = vm.lstObjects.map((o) =>
              o.id === item.id ? { ...o, ...result.product } : o
            )
            vm.$notify({
              type: 'success',
              text: 'Produto já vendido — inativado (não excluído)',
            })
            return
          }
          // Fallback: reload list
          vm.fetchList(vm.page)
          vm.$notify({ type: 'success', text: 'Operação concluída' })
        })
        .catch((err) => {
          if (err?.message) {
            vm.$notify({ type: 'warn', text: err.message })
          }
        })
    },
  },
  computed: {
    groupSelected() {
      return api.storage.isGroupSelected()
    },
    activeCategories() {
      return (this.categories || []).filter((c) => c.active !== false)
    },
    categoryFilterItems() {
      return [
        { title: 'Todas', value: null },
        ...this.activeCategories.map((c) => ({ title: c.name, value: c.id })),
      ]
    },
    variantComboCount() {
      const axes = (this.categoryForm?.fields || []).filter(
        (f) => f.role === 'variant' && f.active !== false && f.type === 'select'
      )
      if (!axes.length) return 0
      return axes.reduce((acc, f) => {
        const n = Array.isArray(f.options)
          ? f.options.filter((o) => String(o).trim() !== '').length
          : 0
        if (n <= 0) return 0
        return acc * n
      }, 1)
    },
  },
  watch: {
    tab(newVal) {
      if (!this.groupSelected) return
      if (newVal === 'categories') {
        this.fetchCategories(this.categoryPage || 1)
      } else if (newVal === 'products') {
        this.loadCategoriesForProducts()
        if (!this.lstObjects?.length) {
          this.fetchList(this.page || 1)
        }
      }
    },
    'filters.itemsPerPage'(newVal) {
      localStorage['_products_itemsPerPage'] = newVal
    },
    'categoryFilters.itemsPerPage'(newVal) {
      localStorage['_product_categories_itemsPerPage'] = newVal
    },
    page(newVal, oldVal) {
      if (!isNaN(newVal) && newVal !== oldVal && !this.requestingApi && this.tab === 'products') {
        this.fetchList(newVal)
      }
    },
    categoryPage(newVal, oldVal) {
      if (
        !isNaN(newVal) &&
        newVal !== oldVal &&
        !this.requestingCategories &&
        this.tab === 'categories'
      ) {
        this.fetchCategories(newVal)
      }
    },
  },
}
</script>
